import React from "react";
import BackgroundImage from "../../components/BackgroundImage";
import Spinner from "../../components/Spinner";
import { parseForMarkdownBold, parseForMarkdownLinks } from "../../helpers";
import useFetch from "../../hooks/useFetch";

import "./style.scss";

function NotFound() {
  const [staticContent, loading] = useFetch("/static", {});
  
  return loading ? (
    <div className="NotFound">
      <Spinner size="xlarge" centered />
    </div>
  ) : (
    <>
      <BackgroundImage className="NotFound" content={staticContent.not_found}>
        <div
          className="NotFound__content"
          style={{
            color: staticContent.not_found.text_color,
          }}
        >
          <h1 className="NotFound__title">{staticContent.not_found.title}</h1>
          <div
            className="NotFound__description"
            dangerouslySetInnerHTML={{
              __html:
                parseForMarkdownLinks(
                  parseForMarkdownBold(staticContent.not_found.description),
                  staticContent.not_found.link_color, ""
                )
              }}
            />
        </div>
      </BackgroundImage>
    </>
  );
}

export default NotFound;
